const o = "_wrapper_wwsoo_1", t = "_transparent_wwsoo_15", n = "_collapsed_wwsoo_18", s = "_collapseButton_wwsoo_22", p = "_background_wwsoo_58", e = "_innerWrapper_wwsoo_68", _ = "_topSection_wwsoo_76", c = "_bottomSection_wwsoo_83", r = "_input_wwsoo_86", a = {
  wrapper: o,
  transparent: t,
  collapsed: n,
  collapseButton: s,
  background: p,
  innerWrapper: e,
  topSection: _,
  bottomSection: c,
  input: r
};
export {
  p as background,
  c as bottomSection,
  s as collapseButton,
  n as collapsed,
  a as default,
  e as innerWrapper,
  r as input,
  _ as topSection,
  t as transparent,
  o as wrapper
};
